import { Component } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-shared-changes-edit-popup',
    templateUrl: './shared-changes-edit-popup.component.html',
    styleUrls: ['./shared-changes-edit-popup.component.scss'],
    standalone: false
})
export class SharedChangesEditPopupComponent {
  constructor(private modalRef: ModalOverlayRef) {
    this.modalRef.backgroundClicked();
  }

  public yes(): void {
    this.close('yes');
  }

  public no(): void {
    this.close('no');
  }

  public close(msg: string): void {
    this.modalRef.close({ data: msg });
  }
}
